import { createReducer, on } from "@ngrx/store";
import { TransactionsTableActions } from "../../create-request/actions";

export const submitCancelFeatureKey = 'submitCancel';


interface CancelledState {
    isCancelTransactionCallFinished: boolean;
    isCancelTransactionSubmitted: boolean;
    hasCancelTransactionError: boolean;
    hasPendingTransactions: boolean;
    cancelledTransactionId: string;
}

export interface State extends CancelledState { }

export const initialSubmitCancelTransactionState: State = {
    isCancelTransactionCallFinished: false,
    isCancelTransactionSubmitted: false,
    hasCancelTransactionError: false,
    hasPendingTransactions: false,
    cancelledTransactionId: ''
}

export const submitCancelTransactionReducer = createReducer(
    initialSubmitCancelTransactionState,
    on(TransactionsTableActions.cancelTransactionSuccess, (state, { cashieringRequestId }) => {
        return {
            ...state,
            isCancelTransactionCallFinished: true,
            isCancelTransactionSubmitted: true,
            hasCancelTransactionError: false,
            hasPendingTransactions: false,
            cancelledTransactionId: cashieringRequestId
        }
    }),
    on(TransactionsTableActions.cancelTransactionFailure, (state) => {
        return {
            ...state,
            isCancelTransactionCallFinished: true,
            isCancelTransactionSubmitted: false,
            hasCancelTransactionError: true,
            hasPendingTransactions: false,
            cancelledTransactionId: ''
        }
    }),
    on(TransactionsTableActions.resetSubmitCancelTransactionState, (state) => {
        return {
            ...state,
            isCancelTransactionCallFinished: false,
            isCancelTransactionSubmitted: false,
            hasCancelTransactionError: false,
            hasPendingTransactions: false
        }
    }),
    on(TransactionsTableActions.cancelTransactionFailurePendingTransaction, (state =>{
      return {
        ...state,
            isCancelTransactionCallFinished: true,
            isCancelTransactionSubmitted: false,
            hasCancelTransactionError: true,
            hasPendingTransactions: true
      }
    }))
);
